import { FaClock, FaMapMarkerAlt, FaUserTie, FaDollarSign, FaTags, FaBriefcase, FaCalendarAlt, FaPhone, FaUsers, FaEnvelope, FaHourglass, FaTools, FaHammer, FaWrench, FaExchangeAlt, FaComments, FaPaintRoller, FaLayerGroup, FaGlassWhiskey, FaRulerCombined, FaLightbulb, FaCloudSunRain, FaShieldAlt, FaDoorClosed } from 'react-icons/fa';
import { FaBuildingShield, FaVolumeHigh } from 'react-icons/fa6';


// Function to render the appropriate icon based on the name
export const renderIcon = (iconName) => {

  // Convert the name to lowercase
  const lowercaseName = iconName.toLowerCase();

  // Check the lowercase name and return the corresponding icon component
  switch (lowercaseName) {

    /*----- Service Icons -----*/
    case 'installation services':
      return <FaHammer />; // Hammer icon

    case 'repair services':
      return <FaWrench />; // Wrench icon

    case 'replacement services':
      return <FaExchangeAlt />; // Exchange/Swap icon

    case 'consultation services':
      return <FaComments />; // Chat/Comments icon

    case 'customization services':
      return <FaPaintRoller />; // Paint Roller icon

    case 'maintenance services':
      return <FaTools />; // Tools icon

    /*----- Page Sidebar -----*/
    case 'date':
    case 'days':
    case 'deadline':
      return <FaCalendarAlt />; // Calendar icon

    case 'timing':
    case 'hours':
      return <FaClock />; // Clock icon

    case 'duration':
      return <FaHourglass />; // Hourglass icon

    case 'client':
    case 'position':
      return <FaUsers />; // Users icon

    case 'category':
      return <FaTags />; // Tags icon

    case 'location':
      return <FaMapMarkerAlt />; // Location icon

    case 'salary':
    case 'cost':
      return <FaDollarSign />; // Dollar icon

    case 'experience':
      return <FaBriefcase />; // Briefcase icon

    case 'leadspecialist':
      return <FaUserTie />; // Leader icon

    case 'number':
      return <FaPhone />; // Phone icon

    case 'email':
      return <FaEnvelope />; // Email icon

    case 'framematerial':
    case 'material':
      return <FaLayerGroup />; // Layer/Material icon

    case 'glasstype':
      return <FaGlassWhiskey />; // Glass icon

    case 'dimensions':
      return <FaRulerCombined />; // Ruler/Measurement icon

    case 'energyefficiency':
      return <FaLightbulb />; // Lightbulb/Energy icon

    case 'securityfeatures':
      return <FaBuildingShield />; // Building Shield/Security icon


    case 'soundproofing':
      return <FaVolumeHigh />; // Volume/Audio icon

    case 'weatherproofing':
      return <FaCloudSunRain />; // Weather/Cloud with Rain icon

    case 'warranty':
      return <FaShieldAlt />; // Shield/Warranty icon

    case 'customizationoptions':
    case 'finishcolor':
      return <FaPaintRoller />; // Paint Roller/Customization icon

    case 'styledesign':
      return <FaDoorClosed />; // Door/Design Style icon

    case 'hardware':
      return <FaTools />; // Tools/Hardware icon

    default:
      return null; // Return null if no matching icon is found
  }

};